var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('HospitalHeader'),_c('div',{staticClass:"create-reservation common-inner"},[_c('h2',{staticClass:"text-h4 text-center"},[_vm._v("予約の作成")]),_c('CreateReservationForm')],1),_c('ManagementFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }